<mat-toolbar color="primary">
  <mat-progress-bar *ngIf="!initLogin" style="position: absolute; left: 0; top: 0;" mode="indeterminate"></mat-progress-bar>
  <button class="title-home" routerLink="/accueil" routerLinkActive="active" mat-button>DragUploader <span class="version">v{{version}}</span></button>
  <button routerLink="/accueil" routerLinkActive="active" mat-button>Accueil</button>

  <!-- Menu PréSélection Playlist Mensuelle : visible si permission edit_winmedia_preselect_monthly_playlist -->
  <button *ngIf="permissions.includes('edit_winmedia_preselect_monthly_playlist')"
          routerLink="/editPreselectMonthlyPlaylist" routerLinkActive="active" mat-button>PréSélection Playlist Mensuelle</button>

  <!-- Menu PréSélection par Catégorie : visible si permission edit_winmedia_preselect_category -->
  <button *ngIf="permissions.includes('edit_winmedia_preselect_category')"
          routerLink="/editPreselectCategory" routerLinkActive="active" mat-button>PréSélection par Catégorie</button>

  <!-- Élément unique : affiché directement -->
  <button *ngIf="moreMenuCount === 1"
          [routerLink]="singleMoreItem.route" routerLinkActive="active" mat-button>{{ singleMoreItem.label }}</button>

  <!-- Plusieurs éléments : regroupés dans "Administration" -->
  <button *ngIf="moreMenuCount > 1" mat-button [matMenuTriggerFor]="plusMenu">
    Administration <mat-icon iconPositionEnd>expand_more</mat-icon>
  </button>
  <mat-menu #plusMenu="matMenu">
    <!-- Menu Configuration : visible si au moins une permission admin -->
    <button *ngIf="permissions.includes('global_config') || permissions.includes('user_config')"
            mat-menu-item routerLink="/admin" routerLinkActive="active">Configuration</button>
    <!-- Menu Edit Winmedia : visible si permission edit_winmedia_sql -->
    <button *ngIf="permissions.includes('edit_winmedia_sql')"
            mat-menu-item routerLink="/editWinmedia" routerLinkActive="active">Edit Winmedia</button>
    <!-- Menu Spots : visible si permission edit_winmedia_spots -->
    <button *ngIf="permissions.includes('edit_winmedia_spots')"
            mat-menu-item routerLink="/spots" routerLinkActive="active">Spots</button>
  </mat-menu>

  <span class="example-fill-remaining-space"></span>

  <span *ngIf="initLogin && isLoggedIn" class="user-deco">(<span class="logout" (click)="logout()">Déconnexion</span>)</span>
  <span *ngIf="initLogin" class="user-name"
        [class.clickable]="permissions && permissions.includes('edit_personal_settings')"
        (click)="permissions && permissions.includes('edit_personal_settings') && openPersonalSettings()">{{ user.name_label }}</span>
  <img *ngIf="initLogin" [src]="user.picture" [alt]="user.name" class="user-picture"
       [class.clickable]="permissions && permissions.includes('edit_personal_settings')"
       (click)="permissions && permissions.includes('edit_personal_settings') && openPersonalSettings()" />

</mat-toolbar>
